import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Row from '../../../../core/layout/Row';
import Column from '../../../../core/layout/Column';
import TextInput from '../../../../core/form/TextInput';
import FormButtons from '../../../../core/form/FormButtons';
import LocaleSelect from '../../../../core/form/LocaleSelect';

const CanDoForm = (props) => (
  <form
    onSubmit={(event) => {
      event.preventDefault();
      props.onSubmit();
    }}
  >
    <Row>
      <Column size={2}>
        <LocaleSelect
          required
          disabled={props.submitting}
          value={get(props.values, 'locale', '')}
          onChange={(value) => props.onChange('locale', value)}
          errorText={get(props.errors, 'locale', null)}
        />
      </Column>
      <Column size={4}>
        <TextInput
          required
          disabled={props.submitting}
          label="Title"
          value={get(props.values, 'title', '')}
          onChange={(value) => props.onChange('title', value)}
          errorText={get(props.errors, 'title', null)}
        />
      </Column>
      <Column size={6}>
        <TextInput
          required
          disabled={props.submitting}
          label="Description"
          value={get(props.values, 'description', '')}
          onChange={(value) => props.onChange('description', value)}
          errorText={get(props.errors, 'description', null)}
        />
      </Column>
    </Row>
    <FormButtons
      confirmLabel={props.values.id ? 'Update Can Do' : 'Create Can Do'}
      isDisabled={props.submitting || !props.isDirty()}
      isSubmitting={props.submitting}
      onReset={props.onReset}
    />
  </form>
);

CanDoForm.propTypes = {
  onSubmit: PropTypes.func,
  onReset: PropTypes.func,
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  isDirty: PropTypes.func,
};

CanDoForm.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  isDirty: () => false,
  onSubmit: () => alert('submitted'),
  onReset: () => false,
};

export default CanDoForm;
